import { Vault } from '@/features/vaults/types';

export const ethereumTestKeyrock2VaultId = 'ethereum-test-keyrock-2';

export const ethereumTestKeyrock2: Vault = {
  id: ethereumTestKeyrock2VaultId,
  type: 'core-vault',
  name: 'TermMax Looper',
  description: '',
  category: 'core-vault',
  address: '0x6b59026041C560916cC5426c64b2578B95d86143',
  curators: [],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x6b59026041C560916cC5426c64b2578B95d86143',
    },
  ],
  baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  lpTokenSymbol: 'tKR2',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: true,
  },
  archived: false,
};
